import { render, staticRenderFns } from "./ER.vue?vue&type=template&id=00796fe0"
import script from "./ER.vue?vue&type=script&lang=js"
export * from "./ER.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports